module.exports = __webpack_public_path__ + "static/cyber-monday-19bccb67d91d4f040ff70c457d492cdb.svg";